import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
// import LazyLoad from 'react-lazyload';


import "../css/common.css"



import Header from "./header";
import Footer from "./footer";
import BookAppointment from "./book_appointment"
import OurResponsibility from "./our_responsibility"
import favicon from '../images/favicon.png'
import Helmet from 'react-helmet'
import { Link } from "gatsby"

var scroll = false;

const Layout = ({ children }) => (
  <div>
    <Helmet>
  <link rel="icon" href={favicon} />
</Helmet>
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}

 
    render={data => (
      <>
        {/* <Header siteTitle={data.site.siteMetadata.title} /> */}
        {/* <div className="hideHeader"> */}
        <Header />

        {/* </div> */}
       
      
       
        <div 
        // style={{
        //   margin: `0 auto`,
        //   maxWidth: 960,
        //   padding: `0px 1.0875rem 1.45rem`,
        //   paddingTop: 0,
        // }}
        >
          <main>
          <div class="wrapper"> 
            {children}
            </div>
            </main>
            <OurResponsibility/>
         <BookAppointment appointmentContent="Submit an enquiry. You'll receive a call from our team in 48 hours. Get a free consultation. Get a quotation & decide on the treatment."/>  
        <Footer />
        
           
         
        </div>
      </>
    )}
  />
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
